<template>
    <span>
        <div class="contenedor">
            <div style="padding-right: 10px; margin-top: 10px">
                <reposive-menu></reposive-menu>
                <section-video></section-video>
            </div>
            <div class="show">
                <span v-if="spiner == true" style="display: flex; flex-direction: row; justify-content: center; padding-top: 100px">
                    <v-progress-circular v-if="spiner"
                                         :size="50"
                                         :width="5"
                                         color="purple"
                                         indeterminate
                                         >
                </v-progress-circular>
                </span>
                <span v-else>
                    <modules></modules>
                </span>
            </div>
        </div>

    </span>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    import Modules from './Modules_Courses/modules_in_course.vue'
    import SectionVideo from './Modules_Courses/section_video/section_video_store.vue'
    import reposiveMenu from './Modules_Courses/responsive-menu.vue'
    export default {
        name: 'CourseIn',
        components: {
            reposiveMenu,
            SectionVideo,
            Modules,
        },
        created(){
            this.getCourseDescription();
            this.getDate();
        },
        data(){
            return {
                proyect_id  : process.env.VUE_APP_PROYECT_ID,
                id          : this.$route.params.courseId,
                courseDetail:{},
                spiner: false,
                color: '#F4511E',
                size:'',

            }
        },
        computed: {
            ...mapState,
            ...mapGetters({

                drawer_true:'drawer_true',
                video_finish: 'course/video_finish'
        }),
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
            mounted_course_id(){
                return JSON.parse(localStorage.getItem('mountedCourseId'));
            }

        },
        methods:{
            getCourseDescription:function () {
                /*this.$store.commit('vimeo_Id', '');*/
                this.spiner = true;
                this.$store.commit('course/allResources', '');
                var url = '/api/v1/getUserCourseDetail';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    user_id  : this.userId.id,
                    mounted_course_id: this.mounted_course_id,
                }).then(response => {
                    this.courseDetail = response.data;
                    this.$store.commit('course/coureseId', (response.data.mounted_curses));
                    this.$store.commit('course/allModules', (response.data.mounted_curses.modules));
                    this.spiner = false;
                })

            },
            getDate:function () {
                var url = '/api/v1/getDate';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                }).then(response => {
                    this.$store.commit('date', (response.data));
                })

            }

        },
        watch:{
            video_finish(new_value, old_value){
                if (new_value === true){
                    this.getCourseDescription();
                }
            }
        }

    }
</script>
<style>
    .contenedor{
        display: grid;
        grid-template-columns: 65% 1fr;
        grid-template-rows: 2fr 1fr;
        margin-top: 63px;
    }

    .title-contenido{
        width: 100%;
        height: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 10px;
        background: #eeeeee;
        font-size: 1.4rem;
        position: fixed;
    }



    .marginLeft{
        padding-left: 80px !important;
    }
    @media (min-width: 181px) and (max-width: 1023px) {

        .show {
            display: none;
        }

        .contenedor {
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: 10px 1fr 1fr 1fr;
            margin-top: 50px;

        }
    }
</style>